import { fetchAuthSession, signOut } from 'aws-amplify/auth';

export const makeAuthenticatedRequest = async (url: string, options: RequestInit = {}) => {
  try {
    const session = await fetchAuthSession();
    if (!session?.tokens?.idToken) {
      console.error("No valid token available");
      await handleLogout();
      throw new Error("Session expired - Please log in again");
    }

    const token = session.tokens.idToken.toString();
    const response = await fetch(url, {
      ...options,
      headers: {
        ...options.headers,
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 401 || response.status === 403) {
      console.error("Authentication error:", response.status);
      await handleLogout();
      throw new Error("Session expired - Please log in again");
    }

    return response;
  } catch (error) {
    if (error instanceof Error && 
        (error.message.includes("No valid token available") || 
         error.message.includes("Session expired"))) {
      await handleLogout();
    }
    throw error;
  }
};

export const makeAuthenticatedRequestSBU = async (url: string, options: RequestInit = {}) => {
  try {
    const session = await fetchAuthSession();
    if (!session?.tokens?.idToken) {
      console.error("No valid token available");
      await handleLogout();
      throw new Error("Session expired - Please log in again");
    }

    const token = session.tokens.idToken.toString();
    const response = await fetch(url, {
      ...options,
      headers: {
        ...options.headers,
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (response.status === 401 || response.status === 403) {
      console.error("Authentication error:", response.status);
      await handleLogout();
      throw new Error("Session expired - Please log in again");
    }

    return response;
  } catch (error) {
    if (error instanceof Error && 
        (error.message.includes("No valid token available") || 
         error.message.includes("Session expired"))) {
      await handleLogout();
    }
    throw error;
  }
};

export const handleLogout = async () => {
  try {
    await signOut();
    // Force reload the page to clear any cached state
    window.location.href = '/login';
  } catch (error) {
    console.error("Error during logout:", error);
    // Force reload even if signOut fails
    window.location.href = '/login';
  }
};

